import { connect } from 'react-redux'
import {
  setAddingLogo,
  saveLogo,
  getLogo,
  deleteLogo,
  invalidLogo
} from '../../actions/index'
import Logo from '../../components/profile/logo.component'

const mapStateToProps = (state) => {
  const { client } = state
  const userType = client.user.data[5]
  return {
    logo: state.logo.logo,
    logoSaved: state.logo.logoSaved,
    logoSaveFailed: state.logo.logoSaveFailed,
    addingLogo: state.logo.addingLogo,
    deleteLogoSuccess: state.logo.deleteLogoSuccess,
    deleteLogoFailed: state.logo.deleteLogoFailed,
    isInvalidLogo: state.logo.isInvalidLogo,
    isCorruptLogo: state.logo.isCorruptLogo,
    userType        
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    setAddingLogo: (addingLogo) => dispatch(setAddingLogo(addingLogo)),
    saveLogo: (file) => dispatch(saveLogo(file)),
    getLogo: (data) => dispatch(getLogo(data)),
    deleteLogo: () => dispatch(deleteLogo()),
    invalidLogo: (error) => dispatch(invalidLogo(error))
  }
}

const LogoContainer = connect(mapStateToProps, mapDispatchToProps)(Logo)

export default LogoContainer